import React, { useState } from 'react';

import { Grid, Typography, makeStyles, TextField, Box } from '@material-ui/core';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import * as yup from 'yup';

import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => ({
  addEmailContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    minHeight: '84px',
  },
  buttonContainer: {
    '& button': {
      width: '80px',
    },
    alignItems: 'start',
    display: 'flex',
    margin: '12px 0 !important',
  },
  container: {
    marginTop: '24px',
  },
  deleteIcon: {
    '&:hover': {
      color: 'red',
      cursor: 'pointer',
    },
    display: 'none',
  },
  emailBox: {
    '&:hover': {
      '& svg': {
        display: 'block',
      },
      backgroundColor: '#0000001a',
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '40px',
    padding: '0 16px',
    textAlign: 'center',
  },
  emailInputContainer: {
    display: 'flex',
    flex: 1,
    padding: '0 !important',
  },
  emailsField: {
    display: 'flex',
    flexGrow: 1,
    padding: '8px',
    width: '100%',
  },
}));

export default ({ onSaveEmailsForPlacedOrders, emailsForPlacedOrders = [] }) => {
  const [emailInput, setEmailInput] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const classes = useStyles();

  const handleEmail = (event) => {
    const email = event.target?.value || '';

    setEmailInput(email.toLowerCase());
    setErrorMessage('');
  };

  const validateEmail = () => {
    const emailSchema = yup.string().email('Invalid email format');

    try {
      emailSchema.validateSync(emailInput);
      setErrorMessage('');
      return true;
    } catch (error) {
      setErrorMessage(error.message || '');
      return false;
    }
  };

  const handleAddEmailButton = () => {
    const isEmailValid = validateEmail();

    if (!isEmailValid) return;

    if (emailsForPlacedOrders.includes(emailInput)) {
      setErrorMessage('Email already on the list');
      return;
    }

    if (emailsForPlacedOrders.length >= 5) {
      setErrorMessage('You can only add 5 emails');
      return;
    }

    const emails = [...emailsForPlacedOrders, emailInput];

    onSaveEmailsForPlacedOrders(emails);

    setEmailInput('');
  };

  const handleEmailDelete = (email) => {
    const emails = emailsForPlacedOrders.filter((listEmail) => listEmail !== email);

    onSaveEmailsForPlacedOrders(emails);
  };

  return (
    <Grid container className={classes.container}>
      <Grid item>
        <Typography variant="h6" align="left" gutterBottom>
          Emails
        </Typography>

        <Typography variant="div" align="left" paragraph>
          Add additional emails that should receive the placed orders notification emails.
        </Typography>

        <Grid container spacing={3} className={classes.addEmailContainer}>
          <Grid item className={classes.emailInputContainer}>
            <TextField
              error={!!errorMessage}
              value={emailInput}
              className={classes.emailsField}
              onChange={handleEmail}
              placeholder="example@email.com"
              helperText={errorMessage}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>

          <Grid item className={classes.buttonContainer}>
            <LoadingButton color="primary" disabled={!emailInput} style={{ marginTop: '0' }} variant="contained" size="medium" onClick={handleAddEmailButton}>
              Add
            </LoadingButton>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            {emailsForPlacedOrders.map((email) => (
              <Box className={classes.emailBox}>
                <Typography variant="div" align="left">
                  {email}
                </Typography>

                <div title="Remove Email">
                  <DeleteOutlinedIcon className={classes.deleteIcon} onClick={() => handleEmailDelete(email)} />
                </div>
              </Box>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
